import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontRoboto, theme } from "shared/lib/styles";

import { ArticleSpeechInlineWidgetGeneric } from "scmp-app/components/article/article-speech/article-speech-inline-widget/variants/generic";
import {
  Container as IconContainer,
  StyledIconHeadphoneSvg,
} from "scmp-app/components/article/article-speech/article-speech-inline-widget/variants/generic/button/headphone-icon/styles";
import {
  MinifyContainer,
  StyledCloseIcon,
  Text,
} from "scmp-app/components/article/article-speech/article-speech-inline-widget/variants/generic/button/styles";
import { IconWrapper } from "scmp-app/components/article/article-speech/article-speech-inline-widget/variants/generic/empty-button/styles";

export const StyledArticleSpeechInlineWidgetGeneric = styled(ArticleSpeechInlineWidgetGeneric)`
  ${IconWrapper} {
    order: 1;

    background-color: transparent;
  }

  ${StyledCloseIcon} {
    order: 3;
  }

  ${IconContainer} {
    order: 1;
  }

  ${StyledIconHeadphoneSvg} {
    inline-size: auto;
  }
`;

const textStyle = css`
  font-weight: 400;
  font-size: 12px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: normal;

  ${theme.breakpoints.up("tablet")} {
    font-size: 14px;
  }
`;

type ContainerProps = {
  $withMinifyText: boolean;
};
export const Container = styled.div<ContainerProps>`
  --article-speech-text-color: #000000;

  ${props => {
    if (props.$withMinifyText) {
      return css`
        min-inline-size: 90px;
        padding-inline: 8px 10px;

        border: 1px solid #cccccc;
        border-radius: 50px;
      `;
    }
  }}

  ${MinifyContainer}, ${IconWrapper} {
    display: flex;
    flex-flow: row nowrap;
    gap: 8px;
    justify-content: center;
    align-items: center;

    inline-size: auto;
    block-size: 36px;
    padding: 0;

    ${textStyle};

    ${Text} {
      font-weight: 400;
      font-size: 12px;

      ${theme.breakpoints.up("tablet")} {
        font-size: 14px;
      }
    }
  }

  ${Text} {
    ${textStyle};
    order: 2;
  }
`;
